import BottomSheet from '@gorhom/bottom-sheet';
import { useRef } from 'react';

interface UseBottomsheetParams {}

interface UseBottomsheet {
  bottomsheetRef: React.RefObject<BottomSheet>;
  onClose: () => void;
  onOpen: () => void;
}

export const useBottomsheet = (): UseBottomsheet => {
  const bottomsheetRef = useRef<BottomSheet>(null);

  function onClose() {
    bottomsheetRef.current?.close();
  }

  function onOpen() {
    bottomsheetRef.current?.expand();
  }

  return {
    bottomsheetRef,
    onClose,
    onOpen
  };
};
